<script setup lang="ts">
import { computed } from "vue";
import { useRouter } from "vue-router";
import {
  taskDependencies,
  taskDependencyWarnings,
} from "@/services/v2/tasks";

const router = useRouter();

const warningItems = computed(() => taskDependencyWarnings.value);

const handleProceed = () => {
  taskDependencies.value = false;
};

const handleClose = () => {
  taskDependencies.value = false;
  router.back();
};
</script>

<template>
  <div
    v-if="taskDependencies"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  >
    <div class="bg-white space-y-6 rounded-lg shadow-lg p-6 max-w-md w-full">
      <div>
        <h2 class="text-xl font-semibold mb-2">Unresolved Dependencies</h2>
        <p class="text-gray-700">
          This task depends on unfinished work. Proceeding may result in data inconsistency.
        </p>
      </div>

      <div v-if="warningItems.length" class="space-y-2">
        <div
          v-for="item in warningItems"
          :key="`${item.key || item.title}-${item.reason}`"
          class="rounded border border-red-200 bg-red-50 px-3 py-2"
        >
          <p class="font-medium text-red-800">{{ item.title }}</p>
          <p class="text-sm text-red-700">
            {{ item.reason }}
            <span v-if="item.status">({{ item.status }})</span>
          </p>
        </div>
      </div>
      <p v-else class="rounded border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
        The server reported unresolved dependencies but did not include dependency details.
      </p>

      <div class="flex gap-2 items-center">
        <button
          class="bg-[#dc2626] hover:bg-[#dc2626]/80 text-white transition-all px-4 py-1 rounded"
          @click="handleProceed"
        >
          Proceed anyway
        </button>
        <button
          class="bg-primary hover:bg-primary/80 transition-all text-white px-4 py-1 rounded"
          @click="handleClose"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</template>
